export default "__VITE_ASSET__C3WhrJna__"